import React, { useState, useRef } from "react";
import {
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
} from "@mui/material";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import {
  copyCrossingTradesForExcel,
  downloadCrossingTradesAsExcel,
} from "../utils/crossingTradesExport";

const CrossingTradesExportButtons = ({ rows, tableHeader }) => {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);

  const handleToggle = () => setOpen((prev) => !prev);

  const handleClose = () => setOpen(false);

  const handleExport = (action) => {
    setOpen(false);
    if (action === "copy") {
      copyCrossingTradesForExcel(rows, tableHeader);
    } else {
      downloadCrossingTradesAsExcel(rows, tableHeader);
    }
  };

  return (
    <>
      <Tooltip title="Export">
        <IconButton
          ref={anchorRef}
          size="small"
          onClick={handleToggle}
          aria-controls={open ? "export-menu" : undefined}
          aria-expanded={open ? "true" : undefined}
          aria-haspopup="menu"
          sx={{ p: 0.5 }}
        >
          <FileDownloadOutlinedIcon sx={{ fontSize: 20 }} />
        </IconButton>
      </Tooltip>

      <Menu
        id="export-menu"
        anchorEl={anchorRef.current}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{
          paper: {
            sx: { minWidth: 120 },
          },
        }}
      >
        <MenuItem
          onClick={() => handleExport("copy")}
          sx={{ fontSize: "12px", minHeight: 32 }}
        >
          Copy
        </MenuItem>
        <MenuItem
          onClick={() => handleExport("download")}
          sx={{ fontSize: "12px", minHeight: 32 }}
        >
          Download CSV
        </MenuItem>
      </Menu>
    </>
  );
};

export default CrossingTradesExportButtons;
